import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const sessionId = m[1];
    (async () => {
      try {
        // Defensive: clear any stale token before exchanging so the existing /me check
        // doesn't run against an expired JWT.
        setToken(null);
        const r = await api.post("/auth/session", { session_id: sessionId });
        // Store our app's JWT so subsequent Authorization header calls work
        if (r.data.access_token) setToken(r.data.access_token);
        setUser(r.data.user);
        // Clean fragment and route to portfolio
        window.history.replaceState({}, "", "/portfolio");
        toast.success(`Welcome, ${r.data.user.name || r.data.user.email}`);
        navigate("/portfolio", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        const msg = e.response?.data?.detail || "Authentication failed";
        toast.error(msg);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="text-center">
        <div className="text-sm text-zinc-500 uppercase tracking-[0.2em]">
          Authenticating
        </div>
        <div className="font-display text-2xl mt-2 text-zinc-950">
          Signing you in...
        </div>
      </div>
    </div>
  );
}
